import { useRef, Fragment } from 'react';
import { Button, Col, Row } from 'antd';
import { UploadOutlined, ExportOutlined } from '@ant-design/icons';
import { Droppable } from 'react-beautiful-dnd';
import classNames from 'classnames';
import dropImg from '../assets/drop-here-courses_2.png';
import Course from './Course';
import {importJsonFile} from "../../Utils";

const SelectedCourses = ({ columns, courses, draggedCourse, importData, removeCourse, openAddModal, rsSkillsGroup }) => {
  const fileInputRef = useRef();

  function exportJsonFile() {
    const years = ['1-w', '1-s', '2-w', '2-s', '3-w', '3-s'];
    const items = [];
    years.forEach((colId) => {
      const col = columns[colId] || { courseIds: [] };
      col.courseIds.forEach((courseId) => {
        items.push({ ...courses[courseId], position: colId });
      });
    });
    const blob = new Blob([JSON.stringify({ courses: items }, null, 2)], {
      type: 'application/json',
    });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'my-curricula.json';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(link.href);
  }

  function printDroppable(columnId) {
    const col = columns[columnId] || { courseIds: [] };
    const currentDragged = draggedCourse ? courses[draggedCourse] : null;
    const isDropDisabled = currentDragged === null ? false : col.semester === currentDragged.semester ? false : true;
    return (
      <Droppable key={columnId} droppableId={columnId} isDropDisabled={isDropDisabled}>
        {(provided, snapshot) => {
          const listClass = classNames('list-selected', {
            'drag-over': snapshot.isDraggingOver,
          });
          return (
            <div ref={provided.innerRef} {...provided.droppableProps} className={listClass}>
              {col.courseIds.map((cid, idx) => (
                <Course key={courses[cid].id} course={courses[cid]} index={idx} removeCourse={removeCourse} openAddModal={openAddModal} rsSkillsGroup={rsSkillsGroup} columnId={columnId} />
              ))}
              {provided.placeholder}
              {col.courseIds.length === 0 && <img src={dropImg} className="drop-img" alt="Drop here" />}
            </div>
          );
        }}
      </Droppable>
    );
  }

  return (
    <Col xs={24} lg={12} xl={8} className="base-selected">
      <h3 className="section-title">Your Curricula</h3>
      <div className="base-selected-content">
        <div className="base-selected-content-scroll">
          <div className="buttons-container">
            <input type="file" accept="application/json" ref={fileInputRef} className="file-input-hidden" onChange={(e) => importJsonFile(e,importData)} />
            <Button icon={<UploadOutlined />} onClick={() => fileInputRef.current.click()} className="button import">
              Import
            </Button>
            <Button icon={<ExportOutlined />} onClick={exportJsonFile} className="button export">
              Export
            </Button>
          </div>

          {['1st year', '2nd year', '3rd year'].map((label, yi) => (
            <Fragment key={yi}>
              <h5 className={`zone-title${yi < 1 ? ' first' : ''}`}>{label}</h5>
              <Row>
                <Col span={12}>
                  <h6 className="semester-title">winter semester</h6>
                  {printDroppable(`${yi + 1}-w`)}
                </Col>
                <Col span={12}>
                  <h6 className="semester-title">summer semester</h6>
                  {printDroppable(`${yi + 1}-s`)}
                </Col>
              </Row>
            </Fragment>
          ))}
        </div>
      </div>
    </Col>
  );
};

export default SelectedCourses;
